import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, useSpring, useMotionValue } from 'framer-motion';
interface MetricCounterProps {
  value: number;
  label: string;
  suffix?: string;
  prefix?: string;
}
export const MetricCounter: React.FC<MetricCounterProps> = ({
  value,
  label,
  suffix = '',
  prefix = ''
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    duration: 2000,
    bounce: 0
  });
  const [displayValue, setDisplayValue] = useState(0);
  useEffect(() => {
    if (isInView) {
      motionValue.set(value);
    }
  }, [isInView, value, motionValue]);
  useEffect(() => {
    springValue.on('change', latest => {
      setDisplayValue(Math.round(latest));
    });
    return () => springValue.destroy();
  }, [springValue]);
  return <div ref={ref} className="text-center p-6" data-id="element-120">
      <div className="text-4xl md:text-5xl font-bold text-[#0A2540] mb-2" data-id="element-121">
        {prefix}
        {displayValue.toLocaleString()}
        {suffix}
      </div>
      <div className="text-gray-600 font-medium uppercase tracking-wide text-sm" data-id="element-122">
        {label}
      </div>
    </div>;
};